import React, { useState, useEffect, useCallback } from "react";
import Select from "react-select";
import PackageDetails from "./PackageDetails";
import AddPickupAddress from "./PickupAddress";
import axios from "axios";
import AddReceiverAddress from "./AddReceiverAddress"; // Adjust path as needed
import { MdLocalShipping } from "react-icons/md";
import { FiTruck, FiArrowLeft } from "react-icons/fi";
import { useNavigate } from "react-router-dom";

const NewOrder = () => {
  const [isModalOpen1, setIsModalOpen1] = useState(false); // Pickup Address Modal
  const [pickupAddress, setPickUpAddress] = useState([]); // Pickup Address List
  const [reciveAddress, setReciveAddress] = useState([]); // Receiver Address List
  const [Recive, setRecive] = useState(null); // Selected Receiver Address
  const [Pickup, setPickUp] = useState(null); // Selected Pickup Address
  const [refresh, setRefresh] = useState(false);
  const navigate = useNavigate();

  const REACT_APP_BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

  // Fetch Pickup Addresses
  useEffect(() => {
    const fetchPickupAddresses = async () => {
      try {
        const token = document.cookie.split("=")[1]; // Extract token
        const response = await axios.get(
          `${REACT_APP_BACKEND_URL}/order/pickupAddress`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setPickUpAddress(response.data.data || []);
      } catch (error) {
        console.error("Error fetching pickup addresses:", error);
      }
    };
    fetchPickupAddresses();
  }, [refresh]);

  // Memoized function to handle Receiver Address updates
  const handleSetReceiverAddress = useCallback((newAddress) => {
    setReciveAddress([newAddress]); // Pass only the new address
    setRecive(newAddress);
  }, []);

  // Handle Pickup Address Selection
  const handlePickupChange = (selectedOption) => {
    if (selectedOption?.value !== "no_address") {
      const selectedPickup = pickupAddress.find(
        (address) => address._id === selectedOption.value
      );
      setPickUp(selectedPickup || null);
    } else {
      setPickUp(null);
    }
  };

  // Prepare Pickup Address Options
  const pickupOptions =
    pickupAddress.length > 0
      ? pickupAddress.map((address) => ({
          value: address._id,
          label: address.pickupAddress?.contactName || "Unnamed Contact",
        }))
      : [{ value: "no_address", label: "No pickup addresses available" }];

  return (
    <div className="sm:p-2 min-h-screen max-w-full mx-auto">
     <h1 className="text-[12px] md:text-[15px] font-[600] text-gray-700 mb-2 text-left flex items-center gap-2">
        <FiArrowLeft
          className="text-[26px] sm:w-8 sm:h-8 w-6 h-6 md:text-[20px] bg-gray-300 hover:bg-gray-400 text-gray-700 rounded-full p-2 cursor-pointer transition-colors duration-200"
          onClick={() => navigate(-1)}
        />
        New Order
      </h1>

      <div className="bg-white shadow-md rounded-2xl p-4 sm:p-4 space-y-4">
        {/* Grid Layout for Pickup and Delivery Info */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          {/* Order Pickup Info */}
          <div className="border rounded-lg p-4 bg-white border-[#0CBB7D] hover:shadow-sm transition-shadow">
            <h2 className="text-[12px] md:text-[16px] font-[600] text-gray-700 mb-4 text-center md:text-left flex items-center gap-2">
              <span className="bg-[#0CBB7D] text-white rounded-lg p-2 md:p-2">
                <FiTruck className="text-[12px] md:text-[16px]" />
              </span>
              Pickup Address
            </h2>
            <Select
              options={pickupOptions}
              onChange={handlePickupChange}
              className="w-full rounded-lg text-[10px]"
              styles={{
                control: (base, state) => ({
                  ...base,
                  backgroundColor: "white", // Tailwind green-50
                  borderColor: state.isFocused ? "#d1d5db" : "#d1d5db", // green-600 or gray-300
                  boxShadow: state.isFocused
                    ? "0 0 0 2px rgba(209, 213, 219)" // gray-300 shadow
                    : "none",
                  "&:hover": {
                    borderColor: "#d1d5db",
                  },
                  minHeight: "38px",
                  fontSize: "12px",
                  borderRadius: "0.25rem", // Tailwind rounded-xl
                }),
                option: (base, { isSelected, isFocused }) => ({
                  ...base,
                  backgroundColor: isSelected
                    ? "#16a34a" // selected
                    : isFocused
                    ? "#bbf7d0" // hover
                    : "#ffffff",
                  color: isSelected ? "#ffffff" : "#1f2937",
                  fontWeight: isSelected ? "400" : "normal",
                  fontSize: "12px",
                }),
                menu: (base) => ({
                  ...base,
                  zIndex: 50,
                }),
              }}
            />
            <button
              onClick={() => setIsModalOpen1(true)}
              className="mt-3 text-[#0CBB7D] hover:underline hover:text-green-500 text-[12px] font-[600]"
            >
              + Add new pickup address
            </button>
            {/* Selected Pickup Address Display */}
            {Pickup && (
              <div className="mt-3 text-[12px] space-y-1 bg-green-50 rounded-lg p-2 text-gray-700">
                <p>
                  <span className="font-semibold text-[12px]">
                    Contact Name :{" "}
                  </span>{" "}
                  {Pickup.pickupAddress?.contactName}
                </p>
                <p>
                  <span className="font-semibold text-[12px]">Address : </span>{" "}
                  {Pickup.pickupAddress?.address}, {Pickup.pickupAddress?.city},{" "}
                  {Pickup.pickupAddress?.pinCode}
                </p>
              </div>
            )}
          </div>
          {/* Order Delivery Info */}
          <div className="border border-[#0CBB7D] rounded-lg p-4 bg-white hover:shadow-sm transition-shadow">
            <h2 className="text-[12px] md:text-[16px] font-[600] text-gray-700 mb-4 text-center md:text-left flex items-center gap-2">
              <span className="bg-[#0CBB7D] text-white rounded-lg p-2 md:p-2">
                <FiTruck className="text-[12px] md:text-[16px]" />
              </span>
              Delivery Details
            </h2>
            <AddReceiverAddress
              setRefresh={setRefresh}
              setReceiverAddress={handleSetReceiverAddress}
            />
          </div>
        </div>
        {/* Package Details Section */}
        <div>
          {/* <h2 className="text-lg font-bold text-gray-800 mb-4">
            📦 Package Details
          </h2> */}
          <PackageDetails Address={{ Recive, Pickup }} />
        </div>
      </div>
      {/* Modals */}
      <div></div>
      <AddPickupAddress
        isOpen={isModalOpen1}
        onClose={() => setIsModalOpen1(false)}
        setRefresh={setRefresh}
        setPickupAddress={(newAddress) =>
          setPickUpAddress((prev) => [...prev, newAddress])
        }
      />
    </div>
  );
};

export default NewOrder;
